import script from "./UiRowActions.vue?vue&type=script&setup=true&lang=js"
export * from "./UiRowActions.vue?vue&type=script&setup=true&lang=js"

import "./UiRowActions.vue?vue&type=style&index=0&id=2283ac00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2283ac00"]])

export default __exports__